import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  pickReportController: [
    'runtimeConstant',
    '$scope',
    'dashboardService',
    '$filter',
    'saveAsPdf',
    'saveAsXls',
    'filters',
    '$uibModalInstance',
    function (
      runtimeConstant,
      $scope,
      dashboardService,
      $filter,
      saveAsPdf,
      saveAsXls,
      filters,
      $uibModalInstance
    ) {
      'use strict';

      function generateReport() {
        swal.fire({
          title: $filter('translate')('WAIT GENERATING REPORT'),
          icon: 'info',
          showConfirmButton: false,
          showCancelButton: false,
          timer: 3000,
        });

				// eslint-disable-next-line no-console
				console.log('filters: ', filters);

        if ($scope.reportType === '1') saveAsPdf(filters, dashboardService);
        else saveAsXls('tabelaToExport', filters);

        $uibModalInstance.close(true);
      }

      function run() {
        try {
          $scope.generateReport = logWrapper(
            generateReport,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
